import { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
// Import Store
import { useAppSelector } from 'store';
import { selectHeaderNavigation } from 'store/slices/header';
// Import Components
import BlockedBySubscriptionInfo from 'components/common/BlockedBySubscriptionInfo';
import AccessControl from 'components/common/AccessControl';
// Import Constants
import NavigationOption from './NavigationOption';
// Import Hooks
import useHasPermission from 'hooks/UseHasPermission';
import { useGTMEvent } from 'hooks/UseGTM';
// Import Constants
import { BLOCKED_BY_SUBSCRIPTION_CLASSNAME, GACategoryEvents } from 'constants/common';

const { GANavigationCategory } = GACategoryEvents;

const Navigation = ({ setNavigationVisibilityStatus, navigationList }) => {
    const { t } = useTranslation();
    const navigation = useAppSelector(selectHeaderNavigation);
    const { hasSubscriptionSection } = useHasPermission();
    const { logEvent } = useGTMEvent();

    const handleOnClick = (gaEvent, eventLabel) => {
        if (gaEvent) {
            logEvent(GANavigationCategory.name, gaEvent, eventLabel);
        }
        setNavigationVisibilityStatus(false);
    };

    const isActive = (itemRoute, navigationRoute) => {
        const entityPathname = navigationRoute.split('/')[0];
        return itemRoute.startsWith(entityPathname);
    };

    return (
        <div className="navigation-popover-content">
            <div className="content">
                {navigationList.map(
                    (
                        { icon, routeModel, permission, partnerSetting, subscriptionSection, specialUiType, gaEvent },
                        index,
                    ) => {
                        const isBlocked = !hasSubscriptionSection(subscriptionSection);

                        return (
                            <AccessControl key={index} permissions={permission} partnerSetting={partnerSetting}>
                                <BlockedBySubscriptionInfo isBlocked={isBlocked} position="right">
                                    <div
                                        className={classNames({
                                            [BLOCKED_BY_SUBSCRIPTION_CLASSNAME]: isBlocked,
                                            'not-clickable': isBlocked,
                                        })}
                                    >
                                        <NavigationOption
                                            routeModel={routeModel}
                                            className={classNames({
                                                [`option-container-${specialUiType}`]: specialUiType,
                                            })}
                                            title={t(routeModel.name)}
                                            leftCustomElement={icon}
                                            active={isActive(routeModel.path, navigation.route)}
                                            onClick={() => handleOnClick(gaEvent, routeModel.name)}
                                        />
                                    </div>
                                </BlockedBySubscriptionInfo>
                            </AccessControl>
                        );
                    },
                )}
            </div>
        </div>
    );
};

Navigation.propTypes = {
    setNavigationVisibilityStatus: PropTypes.func.isRequired,
    navigationList: PropTypes.array.isRequired,
};

export default memo(Navigation);
